import SettingsIcon from '../media/SettingsIcon.png';
import UserIcon from '../media/UserIcon.png';

export class NavLinks {
  static loginNavLink = {
    key: 'login',
    displayName: 'Login',
    pathName: 'Identity/Account/Login',
    logoImage: null,
    visible: false
  };

  static noAccessNavLink = {
    key: 'no-access',
    displayName: 'No Access',
    pathName: '/NoAccess',
    logoImage: null,
    visible: false
  };

  static profileNavLink = {
    key: 'profile',
    displayName: '',
    pathName: '/authentication/profile',
    logoImage: UserIcon,
    visible: true
  };

  static configurationNavLink = {
    key: 'configuration',
    displayName: 'Configuration',
    pathName: '/Configuration',
    logoImage: SettingsIcon,
    visible: true
  };

  static logoutNavLink = {
    key: 'logout',
    displayName: 'Logout',
    pathName: {
      pathname: '/authentication/logout',
      state: {
        local: true
      }
    },
    logoImage: null,
    visible: true
  };

  static createProfileNavLink(userName) {
    var navLink = {};
    Object.assign(navLink, NavLinks.profileNavLink);
    navLink.displayName = 'Hello ' + userName;
    return navLink;
  }
}
